import React from 'react';
import { UserPlus, FileCheck, CreditCard, PlayCircle, ArrowRight } from 'lucide-react';

export default function AdmissionSteps({ onApplyClick }) {
  const steps = [
    {
      num: "01",
      title: "Select Program & Apply",
      desc: "Fill out the online application form with basic personal and academic details.",
      icon: <UserPlus size={24} color="#D4AF37" />
    },
    {
      num: "02",
      title: "Document Verification",
      desc: "Submit digital copies of 10th, 12th / Graduation marks cards and ID proof for verification.",
      icon: <FileCheck size={24} color="#D4AF37" />
    },
    {
      num: "03",
      title: "Fee Payment / EMI",
      desc: "Pay your semester fee or choose zero-interest monthly EMI installment plan.",
      icon: <CreditCard size={24} color="#D4AF37" />
    },
    {
      num: "04",
      title: "Onboarding & LMS Access",
      desc: "Receive official Student ID & login credentials to access the 24/7 LMS learning portal.",
      icon: <PlayCircle size={24} color="#D4AF37" />
    }
  ];

  return (
    <section style={{ padding: '5rem 0', backgroundColor: '#0F2537', color: '#FFFFFF' }}>
      <div className="container">

        {/* Section Header */}
        <div style={{ textAlign: 'center', maxWidth: '720px', margin: '0 auto 3.5rem auto' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.4rem',
            backgroundColor: 'rgba(212, 175, 55, 0.15)',
            color: '#FEF08A',
            fontWeight: 700,
            fontSize: '0.82rem',
            padding: '0.35rem 0.9rem',
            borderRadius: '9999px',
            marginBottom: '0.75rem'
          }}>
            Simple 4-Step Process
          </div>
          <h2 style={{ fontSize: '2.3rem', fontWeight: 800, color: '#FFFFFF', letterSpacing: '-0.02em' }}>
            Hassle-Free Online Admission Roadmap
          </h2>
          <p style={{ fontSize: '1.05rem', color: '#94A3B8', marginTop: '0.5rem', lineHeight: 1.6 }}>
            Complete your admission 100% online from home in less than 15 minutes.
          </p>
        </div>

        {/* Steps Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '1.75rem',
          position: 'relative'
        }}>
          {steps.map((step, idx) => (
            <div key={idx} className="glass-card-dark" style={{
              padding: '2rem 1.5rem',
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}>
              <div>
                <div style={{
                  display: 'flex',
                  justify: 'space-between',
                  alignItems: 'center',
                  marginBottom: '1.25rem'
                }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '12px',
                    backgroundColor: 'rgba(212, 175, 55, 0.15)',
                    border: '1px solid rgba(212, 175, 55, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    {step.icon}
                  </div>

                  <div style={{
                    fontSize: '2.2rem',
                    fontWeight: 900,
                    color: 'rgba(255, 255, 255, 0.15)',
                    lineHeight: 1
                  }}>
                    {step.num}
                  </div>
                </div>

                <h3 style={{ fontSize: '1.15rem', fontWeight: 800, color: '#FEF08A', marginBottom: '0.5rem' }}>
                  {step.title}
                </h3>

                <p style={{ fontSize: '0.88rem', color: '#CBD5E1', lineHeight: 1.5 }}>
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div style={{ textAlign: 'center', marginTop: '3rem' }}>
          <button
            onClick={() => onApplyClick()}
            className="btn-primary"
            style={{ padding: '0.9rem 2.25rem', fontSize: '1rem' }}
          >
            Start Your Application Now <ArrowRight size={18} />
          </button>
        </div>

      </div>
    </section>
  );
}
